module.exports = __webpack_public_path__ + "img/fluke.efa29afb.png";